import PropTypes from 'prop-types';

const displayName = 'FormBuilder';
const propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  formObject: PropTypes.array.isRequired,
  formData: PropTypes.object,
  billerData: PropTypes.object,
  vaPrefix: PropTypes.array,
  intl: PropTypes.object,
  lang: PropTypes.string,
  valueChanged: PropTypes.func,
  isGenesis: PropTypes.bool,
};
const defaultProps = {
  isGenesis: false,
};

export default { displayName, propTypes, defaultProps };
